import banner from "../../../ui/activity/appstore_chargecard/images/banner.jpg"
import banner1 from "../../../ui/activity/appstore_chargecard/images/banner.png"
import { UsingLocation } from "./store/apple-gift-card/state"

export interface BuyColumn {
  num: string
  groupid?: string
  start_time?: string
  groupid_price?: string
  end_time?: string
  send?: string
  resident?: boolean
}

interface Banner {
  img: any
  url: string
  start_time?: string
  end_time?: string
}

interface ActivityInfo {
  group_id?: string
  start_time?: string
  end_time?: string
}

interface DrmLimit {
  cgiMsg: string
  guideMsg: string
}

interface Fission {
  COUPON_SHARE_URL: string
  fissionGroupid: string
  begin_time: string
  end_time: string
  rules: string
  subscribeGroups: string
  promotionTips: string
}

// 活动专区任务配置
export interface GiftTaskConfigItem {
  footerText: string
  gameName: string
  gameIconUrl: string
  offerId: string
  groupId: string
  taskId: string
  beginTime: string // 是否展示业务的时间
  textBeginTime: string // 文本表示业务开启时间
  endTime: string
  missionPageUrl: string
  logoUrl?: string
  tipsTitle?: string
  tipsText?: string
  priority: number
  monthConfig?: {
    monthTaskId: string
    beginTime: string
    endTime: string
    monthlySubTitle?: string
    footerText?: string
  }
}

export interface bannerTextItem {
  text?: string
  iconUrl?: string
  url?: string
  beginTime: string
  endTime: string
  type: UsingLocation
}
export type ActivityForUsers = ActivityInfo & { usertype: string; nums: string; discount: string }
export interface Info {
  productName: string
  productId: string
  rechargeAgreement: string
  realnameAuthAgreement: string
  customerService: string
  banners: Banner[]
  BUY_COLUMN: BuyColumn[]
  activityInfo: ActivityInfo
  drmLimit: DrmLimit
  fission: Fission
  couponPriceThreshold: number[]
  giftTaskConfig: {
    bannerText: string
    nextGameName?: string
    nextGameIconUrl?: string
    offerId: string
    groupId: string
    taskId: string
    monthTaskId: string
    giftTaskConfigItems: GiftTaskConfigItem[]
    floatingWindow?: {
      text: string
      beginTime: string
      endTime: string
    }
  }
  bannerTexts: bannerTextItem[]
  isDisableCustom: boolean
  externalGift?: { [key: string]: string }
  activityForUsers?: Array<ActivityForUsers>
}

const info: Info = {
  productName: "苹果卡",
  productId: "apple_product",
  rechargeAgreement: "//pay.qq.com/h5/activity/applegiftcard.php",
  realnameAuthAgreement: "//vip.qq.com",
  BUY_COLUMN: [
    {
      send: "",
      num: "6",
      end_time: "",
      groupid: "",
      groupid_price: "",
      start_time: "",
      resident: true
    },
    {
      end_time: "",
      num: "50",
      resident: true,
      groupid: "",
      start_time: "",
      groupid_price: "",
      send: ""
    },
    {
      end_time: "",
      num: "100",
      resident: true,
      groupid: "",
      groupid_price: "",
      start_time: "",
      send: ""
    },
    {
      resident: true,
      num: "500"
    },
    {
      end_time: "",
      num: "1000",
      resident: true,
      groupid: "",
      groupid_price: "",
      start_time: "",
      send: ""
    }
  ],
  customerService: "//pay.qq.com/h5/activity/applegiftcardpolicy.php",
  banners: [
    {
      end_time: "2099/09/05 23:59:59",
      img: "//midas.gtimg.cn/store_config/1632797572683KXmrrvW.jpg",
      start_time: "2021/09/06 00:00:00",
      url: ""
    }
  ],
  activityInfo: {
    group_id: "GOODS2201190554244151",
    end_time: "2022/09/05 23:59:59",
    start_time: "2021/08/30 00:00:00"
  },
  activityForUsers: [
    {
      discount: "0.9",
      usertype: "newuser",
      group_id: "GOODS2401170917401175",
      end_time: "2024/03/03 23:59:59",
      start_time: "2024/02/23 10:00:00",
      nums: "50,100,300,500,1000"
    },
    {
      discount: "0.95",
      usertype: "olduser",
      group_id: "GOODS2401170920537145",
      end_time: "2024/03/03 23:59:59",
      start_time: "2024/02/23 10:00:00",
      nums: "50,100,300,500,1000"
    }
  ],
  drmLimit: {
    cgiMsg: "暂不符合参与条件",
    guideMsg: "你已享受过一次优惠价，本次购买将恢复原价"
  },
  couponPriceThreshold: [100],
  fission: {
    fissionGroupid: "FISS2402200537166792",
    COUPON_SHARE_URL: "https://pay.qq.com/h5/store/apple-card/coupon.html?pf=__mds_share",
    begin_time: "2021/07/08 23:50:00",
    end_time: "2024/07/15 23:59:59",
    rules:
      "苹果卡充值活动 一、活动时间 即日起至2021年7月2日23时59分止。 二、活动参与者资格 本活动的参与者（下称：您）应具备以下全部资格： （1）具有完全民事行为能力或年满16周岁并经法定监护人同意参加本活动的自然人； （2）每个自然人仅可使用一个自己通过实名认证并且绑定Apple ID的微信账号，参与1次9折充值活动，并可以在支付后获得分享礼包的机会。 三、活动规则 1、参与方式 活动期间，符合条件的用户参与苹果App Store 充值活动，可享受1次9折充值优惠； 活动期间，用户每充值成功一次，都可以获得一次分享礼包的机会，礼包可以分享给朋友，也可以自己领取。 2、礼包信息 （1）打开礼包，有机会获得一张充值满100-5元的充值优惠券。优惠券无获取上限制； （2）优惠券可以在充值页单次充值超过100元时使用。单次充值只能使用1张优惠券，不可叠加使用； （3）优惠券的失效时间为2021年7月2日23时59分，如超时未使用，券将自动失效不可使用，请及时关注使用； （4）优惠券在下单时就会被使用，如下单时选择了一张优惠券但最终未完成支付，该优惠券将失效，无法再次使用 四、参与资格、获奖资格的取消 您若有下列任何一种行为或情况的，举办方有权单方面取消您的参与资格、获奖资格等： 1、不符合参与资格的； 2、提供虚假信息的； 3、虚假交易或恶意破坏活动的； 4、以任何机器人软件、蜘蛛软件、爬虫软件、刷奖软件或其它任何自动方式、不正当手段等参与本活动的； 5、有任何违反诚实信用、公序良俗、公平、公正等原则行为的； 6、其他违反相关法律法规、本规则行为的。 五、纳税义务 主办方将各自依法履行个人所得税等相关税费代扣代缴的义务。 六、免责条款 鉴于互联网存在诸多不确定性因素，因此，您理解并同意，如因不可抗力、网络、通讯线路故障、计算机大规模瘫痪及活动中存在大面积作弊行为等非腾讯原因致使本活动出现异常情况或难以继续开展的，腾讯有权采取包括但不限于通过各种方式消除异常情况或调整、暂停、取消本活动等措施，因此造成您损失的，腾讯不承担任何责任。 七、管辖条款 本活动系苹果 App Store 充值活动，资和信提供App Store 充值服务，腾讯充值仅提供充值平台。",
    subscribeGroups: "appleid2021",
    promotionTips: "//midas.gtimg.cn/store_config/1624591237371YYgW8lDv.png"
  },
  giftTaskConfig: {
    bannerText: "消耗苹果余额，领游戏礼包",
    giftTaskConfigItems: [
      {
        footerText: "本周5个礼包待解锁",
        gameName: "王者荣耀",
        gameIconUrl: "//midas.gtimg.cn/store_config/1629958763772YF3UNWYY.png",
        offerId: "1450019044",
        groupId: "TASK211020105903172",
        taskId: "c9e562c572a27b62",
        beginTime: "2021/10/18 0:00:00",
        endTime: "2022/03/06 23:59:59",
        missionPageUrl: "https://pay.qq.com/h5/store/apple-card/task.html?offerId=1450019044&taskType=applecard&pf=__mds_wx_appstore",
        logoUrl: "//midas.gtimg.cn/store_config/1629958557810mqXftxeI.png",
        textBeginTime: "2021/10/18 0:00:00",
        tipsTitle: "",
        tipsText: "",
        priority: 5
      },
      {
        footerText: "本周5个礼包待解锁 ",
        gameName: "金铲铲之战",
        gameIconUrl: "//midas.gtimg.cn/store_config/16311571621778lnxWuUR.png",
        offerId: "1450030204",
        groupId: "TASK210817203248945",
        taskId: "21ad4ccf2be45faf",
        beginTime: "2021/08/29 23:59:59",
        endTime: "2022/03/06 23:59:59",
        missionPageUrl: "https://pay.qq.com/h5/store/apple-card/task.html?offerId=1450030204&taskType=applecard&pf=__mds_wx_appstore",
        logoUrl: "//midas.gtimg.cn/store_config/1634702130501vVu0n2Bf.png",
        monthConfig: {
          monthlySubTitle: "终极",
          monthTaskId: "3a33759a26b0e729",
          beginTime: "2021/08/30 00:00:00",
          endTime: "2021/10/30 23:59:59",
          footerText: ""
        },
        tipsTitle: "周期说明",
        tipsText:
          "本周App Store 累积充值金额，只统计本自然周（周一00:00:00-周日23:59:59）内，在腾讯充值本页面的充值金额。每周一开始自动累积，下周一清零并开始累积新一周的充值金额。",
        textBeginTime: "2021/09/01 00:00:00",
        priority: 2
      },
      {
        monthConfig: {
          footerText: "",
          monthTaskId: "d28461382e1e32ec",
          beginTime: "2021/10/18 0:00:00",
          endTime: "2022/03/06 23:59:59",
          monthlySubTitle: "终极"
        },
        footerText: "本周4个礼包待解锁 ",
        gameName: "QQ飞车",
        gameIconUrl: "//midas.gtimg.cn/store_config/1634650879036a0btJ9Tz.png",
        offerId: "1450015040",
        groupId: "TASK211015164645075",
        taskId: "989e6ad241c7f53f",
        beginTime: "2021/10/18 0:00:00",
        textBeginTime: "2021/10/18 0:00:00",
        endTime: "2022/03/06 23:59:59",
        missionPageUrl: "https://pay.qq.com/h5/store/apple-card/task.html?offerId=1450015040&taskType=applecard&pf=__mds_wx_appstore",
        priority: 4
      },
      {
        monthConfig: {
          footerText: "终极",
          monthTaskId: "060220c4430439e0",
          beginTime: "2021/10/18 0:00:00",
          endTime: "2022/03/06 23:59:59",
          monthlySubTitle: ""
        },
        footerText: "本周4个礼包待解锁 ",
        gameName: "英雄联盟手游",
        gameIconUrl: "//midas.gtimg.cn/store_config/1634695707542L9ZApzHq.png",
        offerId: "1450029577",
        groupId: "TASK211019220859181",
        taskId: "a6fe666a6d7e37ad",
        beginTime: "2021/10/18 00:00:00",
        textBeginTime: "2021/10/18 00:00:00",
        endTime: "2022/09/06 23:59:59",
        missionPageUrl: "https://pay.qq.com/h5/store/apple-card/task.html?offerId=1450029577&taskType=applecard&pf=__mds_wx_appstore",
        priority: 6
      },
      {
        monthConfig: {
          footerText: "",
          monthTaskId: "46333432d13262d2",
          beginTime: "2021/10/18 0:00:00",
          endTime: "2022/03/06 23:59:59",
          monthlySubTitle: "终极"
        },
        footerText: "本周5个礼包待解锁",
        gameName: "天涯明月刀",
        gameIconUrl: "//midas.gtimg.cn/store_config/16346509002763GGw3sdB.png",
        offerId: "1450026248",
        groupId: "TASK211019221711032",
        taskId: "7bf3c7d92c1e262d",
        beginTime: "2021/10/18 0:00:00",
        textBeginTime: "2021/10/18 0:00:00",
        endTime: "2022/09/06 23:59:59",
        missionPageUrl: "https://pay.qq.com/h5/store/apple-card/task.html?offerId=1450026248&taskType=applecard&pf=__mds_wx_appstore",
        priority: 3,
        logoUrl: ""
      },
      {
        monthConfig: {
          footerText: "",
          monthTaskId: "8fd4f3b2aa769055",
          beginTime: "2021/10/18 0:00:00",
          endTime: "2022/3/6 23:59:59",
          monthlySubTitle: "终极"
        },
        footerText: "本周5个礼包待解锁",
        gameName: "数码宝贝",
        gameIconUrl: "//midas.gtimg.cn/store_config/1634695518126ZAXU608L.png",
        offerId: "1450030088",
        groupId: "TASK211019222959827",
        taskId: "32803a992733d878",
        beginTime: "2021/10/18 0:00:00",
        textBeginTime: "2021/10/18 0:00:00",
        endTime: "2022/09/06 23:59:59",
        missionPageUrl: "https://pay.qq.com/h5/store/apple-card/task.html?offerId=1450030088&taskType=applecard&pf=__mds_wx_appstore",
        priority: 1
      }
    ],
    offerId: "1450022280",
    groupId: "TASK210823144941634",
    taskId: "e80bd2edf307b504",
    monthTaskId: "81250ad8a5333198",
    floatingWindow: {
      text: "下滑开启任务，额外领游戏礼包",
      beginTime: "2021/08/30 00:00:00",
      endTime: "2021/10/05 23:59:59"
    }
  },
  bannerTexts: [
    {
      url: "https://pay.qq.com/h5/store/apple-card/task.html?offerId=1450030204&taskType=applecard&pf=__mds_hp_applestore_ads",
      text: "金铲铲之战游戏内使用苹果余额，额外返礼包",
      beginTime: "2021/09/13 00:00:00",
      endTime: "2021/12/31 23:59:59",
      type: UsingLocation.HOME,
      iconUrl: "//midas.gtimg.cn/store_config/16327444221837Jzwg0hJ.png"
    }
  ],
  isDisableCustom: false
}

export const INFO =
  (((window as any).__midasStaticConfig_apple_gift_card as Info) &&
    ((window as any).__midasStaticConfig_apple_gift_card.itemMap.apple_gift_card as Info)) ||
  info

export const REPORT = {
  PAGEVIEW: {
    //首页曝光
    HOME_PAGE: "pageview.applestore_giftcard.homepage",
    //查询签约状态
    QUERY_SIGN_CONTRACT: "pageview.applestore_giftcard.query_sign_contract",
    //查询用户签约成功
    USER_ALREADY_SIGN: "pageview.applestore_giftcard.user_already_sign",
    //查询用户未签约
    USER_NO_SIGN: "pageview.applestore_giftcard.user_no_sign",
    //苹果提示实名信息不一致
    APPLE_SIGN_NOT_MATCH: "pageview.applestore_giftcard.apple_auth_not_match",
    // 此身份信息已绑定其他 Apple ID
    APPLE_AUTH_NOT_MATCH_INVALID: "pageview.applestore_giftcard.apple_auth_not_match_invalid",
    //登陆失败
    LOGIN_ERROR: "pageview.applestore_giftcard.login_error",
    //查询签约状态失败
    CHECK_SIGN_ERROR: "pageview.applestore_giftcard.check_sign_error",
    //获取微信实名信息
    GET_WECHAT_REALNAME_INFO: "pageview.applestore_giftcard.get_wechat_realname_info",
    //获取微信实名信息失败
    GET_WECHAT_REALNAME_INFO_ERROR: "pageview.applestore_giftcard.get_wechat_realname_info_error",

    //苹果实名验证不通过
    APPLE_AUTH_ERROR: "pageview.applestore_giftcard.get_apple_auth_error",
    //下单异常
    PLACE_ORDER_ERROR: "pageview.applestore_giftcard.place_order_error",

    //支付成功
    PAY_SUCCESS: "pageview.applestore_giftcard.pay_success",
    //解绑弹框
    UNBIND_SIGN: "pageview.applestore_giftcard.unbind_alert",
    UNBIND_SIGN_SUCCESS: "pageview.applestore_giftcard.unbind_success",
    UNBIND_SIGN_ERROR: "pageview.applestore_giftcard.unbind_error",
    DRM_LIMIT_QUERY: "pageview.applestore_giftcard.drm_limit_query",
    //查风控限次失败
    DRM_LIMIT_QUERY_FAIL: "pageview.applestore_giftcard.drm_limit_query_error",
    //苹果卡首页券入口曝光
    COUPON_VIEW: "pageview.applestore_giftcard.homepage_coupon",
    FILTER_ITEMS: "pageview.applestore_giftcard.filter_items",
    //活动任务请求失败
    TOTAL_TASK_PROCESS_QUERY_ERROR: "pageview.apple-store_giftcard.total_task_process_query_error",
    TOTAL_TASK_PROC_QUERY_ERROR: "pageview.apple-store_giftcard.total_task_proc_query_error",
    TASK_PROCESS_QUERY_ERROR: "pageview.apple-store_giftcard.task_process_query_error",
    TASK_PROC_QUERY_ERROR: "pageview.apple-store_giftcard.task_proc_query_error",

    [UsingLocation.HOME]: {
      HOME_PAGE: "pageview.wxshop.homepage_applestore"
    },
    GET_PRIVACY_SUC: "pageview.apple-store_giftcard.get_privacy_success",
    GET_PRIVACY_ERROR: "pageview.apple-store_giftcard.get_privacy_error",
    SET_PRIVACY_SUC: "pageview.apple-store_giftcard.set_privacy_success",
    SET_PRIVACY_ERROR: "pageview.apple-store_giftcard.set_privacy_error"
  },
  CLICK: {
    //同意授权
    APPLE_AUTH: "click.applestore_giftcard.allow_apple_auth",
    //输入手机号
    PHONE_INPUT: "click.applestore_giftcard.auth_numinput",
    //输入号码后点击确定去苹果实名验证
    PHONE_CONFIRM_AUTH: "click.applestore_giftcard.phone_confirm_auth",
    //实名校验异常-点击再试一次
    APPLE_AUTH_RETRY: "click.applestore_giftcard.auth_tryagain",
    //点击档位
    PAY: "click.applestore_giftcard.homepage_pay",
    //点击解绑按钮
    UNBIND_SIGN: "click.applestore_giftcard.homepage_unbind",
    //点击确认解绑
    CONFIRM_UNBIND_SIGN: "click.applestore_giftcard.unbind_alert_allow",
    //点击取消解绑
    CANCEL_UNBIND_SIGN: "click.applestore_giftcard.unbind_alert_cancel",
    //点击banner
    BANNER: "click.applestore_giftcard.homepage_banner",
    //点击客服帮助
    CUSTOMER_SERVICE: "click.applestore_giftcard.homepage_cs",
    //自定义档位输入
    CUSTOM_INPUT_NUM: "click.applestore_giftcard.homepage_input",
    //苹果卡首页券入口点击
    COUPON_SHOW: "click.applestore_giftcard.homepage_coupon",
    //点击关联账户按钮
    BIND_SIGN: "click.applestore_giftcard.homepage_bind",
    //礼包领取
    RECEIVE_PACKAGE: "click.applestore_giftcard.homepage_package",
    //开启任务
    START_MISSION_PAGE: "click.applestore_giftcard.homepage_start",
    //前往任务
    ENTER_MISSION_PAGE: "click.applestore_giftcard.homepage_enter",
    [UsingLocation.HOME]: {
      BIND: "click.wxshop.homepage_applestore_bind",
      PAY: "click.wxshop.homepage_applestore_pay",
      INPUT: "click.wxshop.homepage_applestore_input",
      COUPON: "click.wxshop.homepage_applestore_coupon",
      ZONE: "click.wxshop.homepage_applestore_zone"
    }
  }
}
